import { instantsInterceptor, } from '@/api/index';
import axios from "axios";
import { setInterceptors } from "@/api/common/interceptor";

function documentList(form) {
    return instantsInterceptor.post('/service/document/list', form);
}

function historyList(form) {
    return instantsInterceptor.post('/service/document/historylist', form);
}

function pdfHistoryList(form) {
    return instantsInterceptor.post('/service/document/pdfHistoryList', form);
}

function docTypeList(form) {
    return instantsInterceptor.post('/service/document/docTypeList', form);
}

function updateDocTypeOrder(form) {
    return instantsInterceptor.put('/mgmt/document/docTypeOrder', form);
}

// function updateDocType(form) {
//     return instantsInterceptor.put('/service/document/docType', form);
// }

function getDocType(doctypeId) {
    return instantsInterceptor.get('/service/document/docType/' + doctypeId);
}

function uploadDocTypeImg(form) {
    return instantsInterceptor.post('/mgmt/doctype/img/' + form.get('doctypeId'), form);
}

function uploadProdTypeImg(form) {
    return instantsInterceptor.post('/mgmt/prodType/img/' + form.get('prodId'), form);
}

function deleteDocType(form) {
    return instantsInterceptor.post('/mgmt/document/deleteDocType', form);
}

function fetchLanguages() {
    return instantsInterceptor.get('/service/code/languages');
}

function fetchDoctypeForm() {
    return instantsInterceptor.get('/mgmt/doctype/form');
}

function addDocType(form) {
    return instantsInterceptor.post('/mgmt/doctype/form', form);
}

function documentMgmtList(form) {
    return instantsInterceptor.post('/mgmt/document/list', form);
}


function newdocumentList() {
    return instantsInterceptor.post('/mgmt/document/newdocument');
}

function docdetailsList(form) {
    return instantsInterceptor.post('/mgmt/document/docdetails', form);
}

function documentUpdate(form) {
    return instantsInterceptor.post('/mgmt/document/update', form);
}

function docverUpdate(form) {
    return instantsInterceptor.post('/mgmt/document/versionUpdate', form);
}

function updateMaxVersYN(form) {
    return instantsInterceptor.post('/mgmt/document/updateMaxVersYN', form);
}

function docverDelete(form) {
    return instantsInterceptor.post('/mgmt/document/versionDelete', form);
}

function documentDelete(form) {
    return instantsInterceptor.post('/mgmt/document/documentDelete', form);
}

function getSiteList() {
    return instantsInterceptor.get('/mgmt/ecm/sites');
}

function getDoctypes(param) {
    return instantsInterceptor.post('/mgmt/ecm/doctypes', param);
}

function getModels(param) {
    return instantsInterceptor.post('/mgmt/ecm/models', param);
}

function getLangs(param) {
    return instantsInterceptor.post('/mgmt/ecm/langs', param);
}

function getMaplist(param) {
    return instantsInterceptor.post('/mgmt/ecm/maplist', param);
}

function getPublicationlist(param) {
    return instantsInterceptor.post('/mgmt/ecm/publicationlist', param);
}

function createWebhelpVer(param) {
    return instantsInterceptor.post('/mgmt/document/createHtmlVer', param);
}

function createFileVer(formdata) {
    return instantsInterceptor.post('/mgmt/document/createFileVer', formdata);
}

function createPDFVer(formdata) {
    return instantsInterceptor.post('/mgmt/document/createPDFVer', formdata);
}

function versionList(param) {
    return instantsInterceptor.post('/mgmt/document/versionList', param);
}

function preDownload(uid) {
    return instantsInterceptor.get('/document/download/predown?uid=' + uid);
}

function getMainQbar() {
    return instantsInterceptor.get('/document/mainqbar');
}

function getVersionlist(param) {
    return instantsInterceptor.post('/mgmt/ecm/versionlist', param);
}

function checkBookmarkAndFeedbackExist(form) {
    return instantsInterceptor.post('/mgmt/document/check/dataexist', form);
}

function getChildPublicationlist(param) {
    return instantsInterceptor.post('/mgmt/ecm/childPublicationlist', param);
}

function getWebhelpPublishStatus(uid) {
    return instantsInterceptor.post('/mgmt/document/createHtml/status?uid=' + uid);
}
function checkWebhelpPublishExist(uid) {
    return instantsInterceptor.post('/mgmt/document/createHtml/check?uid=' + uid);
}

function getPDFPublishStatus(uid) {
    return instantsInterceptor.post('/mgmt/document/createPDFVer/status?uid=' + uid);
}
function checkPDFPublishExist(uid) {
    return instantsInterceptor.post('/mgmt/document/createPDFVer/check?uid=' + uid);
}

function downExcel(form) {
    let axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
        responseType: 'blob',
    });

    let instance = setInterceptors(axiosInstance);

    return instance.post('/mgmt/document/excel', form);
}

function getDataParser(form) {
    return instantsInterceptor.post('/mgmt/document/parser', form);
}

export {
    documentList,
    historyList,
    docTypeList,
    updateDocTypeOrder,
    addDocType,
    // updateDocType,
    getDocType,
    uploadDocTypeImg,
    deleteDocType,
    fetchLanguages,
    fetchDoctypeForm,
    documentMgmtList,
    newdocumentList,
    docdetailsList,
    documentUpdate,
    docverUpdate,
    updateMaxVersYN,
    docverDelete,
    documentDelete,
    getSiteList,
    getDoctypes,
    getModels,
    getLangs,
    getMaplist,
    getPublicationlist,
    createWebhelpVer,
    createFileVer,
    versionList,
    preDownload,
    getMainQbar,
    uploadProdTypeImg,
    getVersionlist,
    checkBookmarkAndFeedbackExist,
    getChildPublicationlist,
    downExcel,
    getDataParser,
    createPDFVer,
    getWebhelpPublishStatus,
    checkWebhelpPublishExist,
    getPDFPublishStatus,
    checkPDFPublishExist,
    pdfHistoryList
};